import useAsyncData from "../../../../hooks/use-async-data";
import taxiCorporationService from "../../taxi-corporation.service";
import TaxiCorporationUnbilledOrdersList from "./taxi-corporation-unbilled-orders-list";
import TaxiCorporationUnbilledOrdersListParams from "./taxi-corporation-unbilled-orders-list-params";

const useTaxiCorporationUnbilledOrdersList = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<TaxiCorporationUnbilledOrdersList | null>(null);

  const load = async (
    params: TaxiCorporationUnbilledOrdersListParams,
    abortSignal: AbortSignal,
  ) => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await taxiCorporationService.getUnbilledOrdersList(
        params,
        abortSignal,
      );

      setData(data);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useTaxiCorporationUnbilledOrdersList;
